<template>
  <div
    class="w-full h-full flex items-start flex-col justify-end bg-white rounded-xl shadow-md m-1"
  >
    <div
      class="relative w-full h-full flex items-end !rounded-b-[28px] overflow-hidden pt-2"
    >
      <img
        :src="member?.image"
        :alt="member?.name"
        class="w-full h-full object-cover"
      />
    </div>
    <div class="w-full h-[100px] flex items-start flex-col justify-center p-4">
      <p class="text-dark text-xl font-medium mb-0.5">
        {{ $t(member?.name) }}
      </p>
      <p
        class="text-gray"
        style="font-family: &quot;Open Sans&quot;, sans-serif"
      >
        {{ $t(member?.role) }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  member: {
    name: string;
    role: string;
    image: string;
  };
}
defineProps<Props>();
</script>

<style scoped></style>
